const ANIMATING_CLASS = "--animating";
const DURATION = 300;
const timers = new WeakMap();

export function flashQuantity(element, duration = DURATION) {
  if (!element) return;

  element.classList.add(ANIMATING_CLASS);
  clearTimeout(timers.get(element));
  timers.set(
    element,
    setTimeout(() => {
      element.classList.remove(ANIMATING_CLASS);
      timers.delete(element);
    }, duration)
  );
}

export function cancelQuantityFlash(element) {
  if (!element) return;

  clearTimeout(timers.get(element));
  timers.delete(element);
}
